import { z } from 'zod';
export const PERMISSIONS = [
    'organizations.read',
    'organizations.manage',
    'memberships.read',
    'memberships.manage',
    'roles.read',
    'roles.manage',
    'settings.read',
    'settings.manage',
    'work_categories.read',
    'work_categories.manage',
    'project_statuses.read',
    'project_statuses.manage',
    'restoration_settings.read',
    'restoration_settings.manage',
    'properties.read',
    'properties.manage',
    'customer_accounts.read',
    'customer_accounts.manage',
    'receivables.read',
    'receivables.manage',
    'job_files.read',
    'job_files.manage',
    'loss_events.read',
    'loss_events.manage',
    'insurance_claims.read',
    'insurance_claims.manage',
    'inspections.read',
    'inspections.manage',
    'workflow_templates.read',
    'workflow_templates.manage',
    'milestones.read',
    'milestones.manage',
    'milestones.approve',
    'equipment.read',
    'equipment.manage',
    'equipment.deploy',
    'equipment_readings.read',
    'equipment_readings.manage',
    'equipment_maintenance.read',
    'equipment_maintenance.manage',
    'estimates.read',
    'estimates.manage',
    'audit.read',
    'companies.read',
    'companies.manage',
    'contacts.read',
    'contacts.manage',
    'leads.read',
    'leads.manage',
    'leads.convert',
    'opportunities.read',
    'opportunities.manage',
    'projects.read',
    'projects.manage',
    'tasks.read',
    'tasks.manage',
    'notes.read',
    'notes.manage',
    'work_queue.read',
    'work_queue.read_all',
    'documents.read',
    'documents.manage',
    'calendar.read',
    'calendar.manage',
    'calls.read',
    'calls.log',
    'notifications.read',
    'notifications.manage',
    'dashboard.read',
    'reports.read',
    'reports.export',
    'integrations.read',
    'integrations.manage',
];
export const PermissionSchema = z.enum(PERMISSIONS);
export const ROLE_TEMPLATES = {
    administrator: [...PERMISSIONS],
    manager: [
        'organizations.read',
        'memberships.read',
        'roles.read',
        'settings.read',
        'work_categories.read',
        'work_categories.manage',
        'project_statuses.read',
        'project_statuses.manage',
        'restoration_settings.read',
        'restoration_settings.manage',
        'properties.read',
        'properties.manage',
        'customer_accounts.read',
        'customer_accounts.manage',
        'receivables.read',
        'receivables.manage',
        'job_files.read',
        'job_files.manage',
        'loss_events.read',
        'loss_events.manage',
        'insurance_claims.read',
        'insurance_claims.manage',
        'inspections.read',
        'inspections.manage',
        'workflow_templates.read',
        'workflow_templates.manage',
        'milestones.read',
        'milestones.manage',
        'milestones.approve',
        'equipment.read',
        'equipment.manage',
        'equipment.deploy',
        'equipment_readings.read',
        'equipment_readings.manage',
        'equipment_maintenance.read',
        'equipment_maintenance.manage',
        'estimates.read',
        'estimates.manage',
        'audit.read',
        'companies.read',
        'companies.manage',
        'contacts.read',
        'contacts.manage',
        'leads.read',
        'leads.manage',
        'leads.convert',
        'opportunities.read',
        'opportunities.manage',
        'projects.read',
        'projects.manage',
        'tasks.read',
        'tasks.manage',
        'notes.read',
        'notes.manage',
        'work_queue.read',
        'work_queue.read_all',
        'documents.read',
        'documents.manage',
        'calendar.read',
        'calendar.manage',
        'calls.read',
        'calls.log',
        'notifications.read',
        'dashboard.read',
        'reports.read',
        'reports.export',
    ],
    member: [
        'organizations.read',
        'settings.read',
        'work_categories.read',
        'project_statuses.read',
        'restoration_settings.read',
        'properties.read',
        'properties.manage',
        'customer_accounts.read',
        'job_files.read',
        'loss_events.read',
        'loss_events.manage',
        'insurance_claims.read',
        'inspections.read',
        'inspections.manage',
        'workflow_templates.read',
        'milestones.read',
        'milestones.manage',
        'equipment.read',
        'equipment.deploy',
        'equipment_readings.read',
        'equipment_readings.manage',
        'equipment_maintenance.read',
        'equipment_maintenance.manage',
        'estimates.read',
        'companies.read',
        'contacts.read',
        'leads.read',
        'opportunities.read',
        'projects.read',
        'tasks.read',
        'tasks.manage',
        'notes.read',
        'notes.manage',
        'work_queue.read',
        'documents.read',
        'documents.manage',
        'calendar.read',
        'calendar.manage',
        'calls.read',
        'calls.log',
        'notifications.read',
        'dashboard.read',
        'reports.read',
    ],
    viewer: [
        'organizations.read',
        'settings.read',
        'work_categories.read',
        'project_statuses.read',
        'restoration_settings.read',
        'properties.read',
        'customer_accounts.read',
        'job_files.read',
        'loss_events.read',
        'insurance_claims.read',
        'inspections.read',
        'workflow_templates.read',
        'milestones.read',
        'equipment.read',
        'equipment_readings.read',
        'equipment_maintenance.read',
        'estimates.read',
        'companies.read',
        'contacts.read',
        'leads.read',
        'opportunities.read',
        'projects.read',
        'tasks.read',
        'notes.read',
        'work_queue.read',
        'documents.read',
        'calendar.read',
        'calls.read',
        'notifications.read',
        'dashboard.read',
        'reports.read',
    ],
};
